import { render, staticRenderFns } from "./ExpandButton.vue?vue&type=template&id=629ea464"
import script from "./ExpandButton.vue?vue&type=script&lang=ts"
export * from "./ExpandButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports